import { createSlice } from "@reduxjs/toolkit";
import { UserState } from "../../components/models/auth";

const initialState : UserState = {
    email: '',
}

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUserEmail: (state, action) => {
            state.email = action.payload;
        },
        clearUserEmail: (state) => {
            state.email = '';
        },
    },
});

export const { setUserEmail, clearUserEmail } = userSlice.actions;
export default userSlice.reducer;